<template>
  <div :class="layoutClass">
    <div
      id="content-container"
      :class="{ 'show-banner': showBanner && projectLayout, framed: isFramed }"
    >
      <left-nav v-if="projectLayout && !isFramed" />
      <router-view :key="key"></router-view>
      <create-campaign-dialog
        :dialog-visible.sync="dialogVisible"
        :is-template-campaign="isTemplate"
        @shouldRedirect="payload => (shouldRedirect = payload)"
      />
    </div>
  </div>
</template>

<script>
import CreateCampaignDialog from '@/modules/campaign-manage/components/CreateCampaignDialog'
import { projectRoute } from '@/core/helpers'
import { EventBus } from '@/core/EventBus'
export default {
  name: 'Layout',
  components: { CreateCampaignDialog },
  data() {
    return {
      key: '',
      dialogVisible: false,
      isTemplate: false,
      shouldRedirect: false
    }
  },
  mounted() {
    EventBus.$on('show-campaign-create-dialog', async () => {
      // @TODO: Remove 'if' after Campaign create release
      if (!this.$store.state.app.features.campaignLegacyUI) {
        if (this.isFramed) {
          this.openCreateCampaignModalInNewUI()
          return
        }

        await this.$store.dispatch('reloadProjectConfig')
        this.dialogVisible = true
        this.isTemplate = false
      }
    })
    EventBus.$on('show-campaign-template-create-dialog', async () => {
      // @TODO: Remove 'if' after Campaign create release
      if (!this.$store.state.app.features.campaignLegacyUI) {
        if (this.isFramed) {
          this.openCreateCampaignModalInNewUI(true)
          return
        }

        await this.$store.dispatch('reloadProjectConfig')
        this.dialogVisible = true
        this.isTemplate = true
      }
    })
  },
  computed: {
    projectLayout() {
      return !!this.$store.getters.projectId && this.$route.name !== 'Home'
    },

    layoutClass() {
      if (this.$store.getters.projectId) {
        return 'layout-project'
      } else {
        return 'layout-basic'
      }
    },

    showBanner() {
      return this.$store.getters.isProjectNotActive
    },
    isFramed() {
      return window.top !== window.self
    }
  },
  methods: {
    openCreateCampaignModalInNewUI(isTemplate = false) {
      window.parent.postMessage(
        {
          type: 'open_create_campaign_modal',
          isTemplate
        },
        '*'
      )
    }
  },
  watch: {
    dialogVisible(newVal) {
      if (newVal || !this.isFramed || !this.shouldRedirect) {
        return
      }

      if (this.isTemplate && this.$route.name === 'PreMadeTemplatesTab') {
        return
      }

      const routeName = this.isTemplate
        ? 'TemplateCampaignsTab'
        : 'AllCampaignsTab'

      this.$router.push(projectRoute({ name: routeName }))
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/common/components/Layout.vue